import {RoadsoftConfigRequest, useRoadsoftConfigUpdateMutation} from "../../../app/api/api";
import {useFormik} from "formik";
import {RoadsoftConfigField, RoadsoftConfigForm, RoadsoftSubscription} from "../../../app/api/model/roadsoft";
import {getRoadsoftconfigValidationSchema} from "../Detail/validation";
import {useTranslation} from "react-i18next";
import DefaultDialog, {DefaultDialogSize} from "../../../components/Dialog/ClosableDialog";
import {Button, MenuItem, Stack, TextField} from "@mui/material";
import React from "react";
import {camelCase} from "lodash";
import {useSnackbar} from "notistack";
import QueryErrorAlert from "../../../components/QueryErrorAlert";

interface RoadsoftSubscriptionDialogProps {
    open: boolean;
    onClose: () => void;
    organizationId: number;
    organizationCountry: string;
    currentSubscription?: RoadsoftSubscription;
}

export default function RoadsoftSubscriptionDialog({
    open,
    onClose,
    organizationId,
    organizationCountry,
    currentSubscription,
}: RoadsoftSubscriptionDialogProps) {
    const {t} = useTranslation();
    const [roadsoftConfigUpdate] = useRoadsoftConfigUpdateMutation();
    const {enqueueSnackbar} = useSnackbar();

    const initialValues: RoadsoftConfigForm = {
        [RoadsoftConfigField.SUBSCRIPTION]: currentSubscription || RoadsoftSubscription.NOT_BOOKED,
    };

    const formik = useFormik({
        initialValues,
        validationSchema: getRoadsoftconfigValidationSchema(t),
        onSubmit: async (values) => {
            const requestData: RoadsoftConfigRequest = {
                organizationId,
                subscription: values[RoadsoftConfigField.SUBSCRIPTION],
                organizationCountry: organizationCountry,
            };
            await roadsoftConfigUpdate(requestData)
                .unwrap()
                .then(
                    () => {
                        handleClose();
                        enqueueSnackbar(t("generic_savedSuccessfully"), {variant: "success"});
                    },
                    (error) => {
                        return <QueryErrorAlert error={error} />;
                    }
                );
        },
    });

    const handleClose = () => {
        onClose();
    };

    function handleSubmit() {
        formik.handleSubmit();
    }

    const isDisabled = formik.values.subscription === currentSubscription;

    return (
        <DefaultDialog
            open={open}
            onClose={handleClose}
            size={DefaultDialogSize.MEDIUM}
            titleKey="generic_roadsoftSubscription"
            actions={
                <Button onClick={handleSubmit} color="primary" disabled={isDisabled}>
                    {t("action_save")}
                </Button>
            }
        >
            <Stack spacing={2} pt={1}>
                <TextField
                    label={t("generic_roadsoftSubscription")}
                    value={isDisabled ? currentSubscription : formik.values[RoadsoftConfigField.SUBSCRIPTION]}
                    select={true}
                    onChange={(e) => {
                        const value = e.target.value;
                        formik.setFieldValue(RoadsoftConfigField.SUBSCRIPTION, value);
                    }}
                >
                    {Object.values(RoadsoftSubscription).map((subscription) => (
                        <MenuItem value={subscription} key={`subscription-${camelCase(subscription)}`}>
                            {t(`roadsoft_subscription${camelCase(subscription)}`)}
                        </MenuItem>
                    ))}
                </TextField>
            </Stack>
        </DefaultDialog>
    );
}

//<FormControl fullWidth error={formhook.touched.subscription && Boolean(formhook.errors.subscription)}></FormControl>
